import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { AwesomeUsersTable } from './components/AwesomeUsersTable';

export const firstTestPluginPlugin = createPlugin({
  id: 'first-test-plugin',
  routes: {
    root: rootRouteRef,
  },
});

export const FirstTestPluginPage = firstTestPluginPlugin.provide(
  createRoutableExtension({
    name: 'FirstTestPluginPage',
    component: () =>
      import('./components/ExampleComponent').then(m => m.ExampleComponent),
    mountPoint: rootRouteRef,
  }),
);


